import { HashMap, TranslocoService } from '@ngneat/transloco';

export class TranslationHelper {
  static translateWithFallback(key: string, fallback: string, translocoService: TranslocoService, params?: HashMap): string {
    const result = translocoService.translate(key, params);
    return result !== key ? result : fallback;
  }
}
